import { render } from "./ListWarehousesForFactory.vue?vue&type=template&id=c94960da&scoped=true&ts=true"
import script from "./ListWarehousesForFactory.vue?vue&type=script&lang=ts"
export * from "./ListWarehousesForFactory.vue?vue&type=script&lang=ts"

import "./ListWarehousesForFactory.vue?vue&type=style&index=0&id=c94960da&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94960da"]])

export default __exports__